export default __webpack_public_path__ + "static/media/gallery-wip-emitter-cover_06.4e95419b.jpg";